// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Inter-VariableFont_opsz,wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/SourceSans3-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
'Video' component in react-native-video does not lets you override 
these styles (object-fit property is always set to 'contain' and react-native 
stylesheet api does lets you override value that either)
*/

/* requires you to wrap your video component in a view with id='cover'*/

/* Import local fonts */
@font-face {
  font-family: 'Inter';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: 100 900;
  font-style: normal;
}

@font-face {
  font-family: 'SourceSans3';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    format('truetype');
  font-weight: 100 900;
  font-style: normal;
}

#cover video {
  object-fit: cover !important;
  object-position: top !important;
}

input:focus {
  outline: none;
}

#scroll-none::-webkit-scrollbar {
  display: none;
}

#percentageText {
  font-size: 40px;
  font-weight: 800;
  text-align: center;
  font-family: 'inter', sans-serif;
  background: linear-gradient(0deg, #7366ff 0%, #ff6cab 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

#launchText {
  font-size: 40px;
  font-weight: 600;
  font-family: 'inter', sans-serif;
  background: linear-gradient(0deg, #7366ff 0%, #ff6cab 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  text-shadow: -1px 4px 2px rgba(0, 0, 0, .1);
}

#completedText {
  color: #737373;
  font-family: 'inter', sans-serif;
  font-size: 12;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED,uEAAuE;;AAEvE,uBAAuB;AACvB;EACE,oBAAoB;EACpB,+DAA8E;EAC9E,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B;sBACoB;EACpB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,2DAA2D;EAC3D,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,2DAA2D;EAC3D,6BAA6B;EAC7B,oCAAoC;;EAEpC,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,aAAa;AACf","sourcesContent":["/* \n'Video' component in react-native-video does not lets you override \nthese styles (object-fit property is always set to 'contain' and react-native \nstylesheet api does lets you override value that either)\n*/\n\n/* requires you to wrap your video component in a view with id='cover'*/\n\n/* Import local fonts */\n@font-face {\n  font-family: 'Inter';\n  src: url('./assets/fonts/Inter-VariableFont_opsz,wght.ttf') format('truetype');\n  font-weight: 100 900;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'SourceSans3';\n  src: url('./assets/fonts/SourceSans3-VariableFont_wght.ttf')\n    format('truetype');\n  font-weight: 100 900;\n  font-style: normal;\n}\n\n#cover video {\n  object-fit: cover !important;\n  object-position: top !important;\n}\n\ninput:focus {\n  outline: none;\n}\n\n#scroll-none::-webkit-scrollbar {\n  display: none;\n}\n\n#percentageText {\n  font-size: 40px;\n  font-weight: 800;\n  text-align: center;\n  font-family: 'inter', sans-serif;\n  background: linear-gradient(0deg, #7366ff 0%, #ff6cab 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n#launchText {\n  font-size: 40px;\n  font-weight: 600;\n  font-family: 'inter', sans-serif;\n  background: linear-gradient(0deg, #7366ff 0%, #ff6cab 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n\n  text-shadow: -1px 4px 2px rgba(0, 0, 0, .1);\n}\n\n#completedText {\n  color: #737373;\n  font-family: 'inter', sans-serif;\n  font-size: 12;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
